import React from 'react';

import { useClinica } from '../../../hooks/clinica';

type ComponentProps = {
  dataImpressao?: string;
};

const HeaderSimples: React.FC<ComponentProps> = ({ dataImpressao }) => {
  const { imagensClinica } = useClinica();

  const logo =
    imagensClinica.find(img => img.nome === 'logoRelatorio')?.arquivo_url || '';

  return (
    <>
      <img
        src={logo}
        style={{ width: '100%', maxWidth: '200px' }}
        alt="Agenda Facil"
      />{' '}
      {dataImpressao && <>Impresso em {dataImpressao}</>}
    </>
  );
};

export default HeaderSimples;
